import {
  PayeeRequirement,
  PayerEngagement
} from "@wingspanhq/wingspan-api-sdk";
import { selectorIsPayerEngagementActive } from "./selectorIsPayerEngagementActive";
import { selectorIsPayerEngagementEligible } from "./selectorIsPayerEngagementEligible";

/**
 * Whether the client has at least one live assignment that can be paid under.
 * Gates the requirements tab's actions, as v1's `getHasEligibleEngagements` did.
 */
export const selectorHasEligiblePayerEngagement = ({
  engagements,
  requirements
}: {
  engagements: PayerEngagement[];
  requirements: PayeeRequirement[];
}): boolean =>
  engagements
    .filter(selectorIsPayerEngagementActive)
    .some(engagement =>
      selectorIsPayerEngagementEligible({ engagement, requirements })
    );
